import { pushDataLayer } from "../../../Shared/utils/datalayer";
export const pushVBPDataLayer = (data)=>pushDataLayer({
        ...data,
        event: 'event'
    });
export const pushLocationEvent = (d)=>pushDataLayer({
        event: 'event',
        category: 'Location',
        ...d
    });
export const pushExpand = (label)=>pushVBPDataLayer({
        category: 'Location',
        action: 'Unfold',
        label: label
    });
export const pushTag = (label)=>pushVBPDataLayer({
        category: 'Activity tag',
        action: window.location.pathname,
        label: label
    });
export const pushCtaBlockAction = (title, type, label)=>pushVBPDataLayer({
        category: `CTA: ${title}`,
        action: `cta-action-${type}`,
        label: label
    });
export const pushTranslateAction = (label)=>pushVBPDataLayer({
        category: `Translate`,
        action: `change_language`,
        label: label
    });
